import { render, staticRenderFns } from "./SideBarItem.vue?vue&type=template&id=3f898a10&scoped=true&"
import script from "./SideBarItem.vue?vue&type=script&lang=ts&"
export * from "./SideBarItem.vue?vue&type=script&lang=ts&"
import style0 from "./SideBarItem.vue?vue&type=style&index=0&id=3f898a10&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f898a10",
  null
  
)

export default component.exports